import PropTypes from 'prop-types';
import { status } from 'constants/general';
import Loader from 'modules/shared/common/components/Loader';
import Pagination from 'modules/shared/common/components/Pagination';
import MasterListHeader from 'modules/shared/masterList/components/MasterListHeader';
import MasterListTable from 'modules/shared/masterList/components/MasterListTable';
import MasterListFilter from 'modules/shared/masterList/components/MasterListFilter';
import Modal from 'modules/shared/common/components/Modal';
import AddOrEditMasterListComponent from 'modules/shared/masterList/components/AddOrEditMasterListComponent';

import { MasterListWrapper, LoaderWrapper, PaginationWrapper } from './MasterListComponent.style';

const MasterListComponent = ({
  stringsData,
  selectedPageFilter,
  numberOfPages,
  masterListList,
  mappedMasterListList,
  masterListStatusEnum,
  masterListStatusColorEnum,
  handleMasterListSearchBarInputChange,
  handleMasterListPaginationClick,
  masterListQueryStrings,
  formFieldsValues,
  setFormFieldsValues,
  formFieldsValidation,
  isDetailsModalOpen,
  setIsDetailsModalOpen,
  handleConfirmDetailsModalClick,
  handleCancelDetailsModalClick,
  handleMasterListEditButtonClick,
}) => (
  <MasterListWrapper>
    <MasterListHeader
      stringsData={stringsData}
      handelAddMasterListBtnClick={setIsDetailsModalOpen}
    />
    <MasterListFilter
      stringsData={stringsData}
      mappedMasterListList={mappedMasterListList}
      masterListStatusEnum={masterListStatusEnum}
      masterListStatusColorEnum={masterListStatusColorEnum}
      handleMasterListSearchBarInputChange={handleMasterListSearchBarInputChange}
      masterListQueryStrings={masterListQueryStrings}
    />
    {masterListList?.status === status.SUCCESS || masterListList?.status === status.FAIL ? (
      <>
        <MasterListTable
          stringsData={stringsData}
          mappedMasterListList={mappedMasterListList}
          masterListStatusEnum={masterListStatusEnum}
          masterListStatusColorEnum={masterListStatusColorEnum}
          handleMasterListEditButtonClick={handleMasterListEditButtonClick}
        />
        {numberOfPages > 1 && (
          <PaginationWrapper>
            <Pagination
              currentPage={selectedPageFilter}
              totalCount={numberOfPages}
              handleOrderPaginationClick={handleMasterListPaginationClick}
            />
          </PaginationWrapper>
        )}
      </>
    ) : (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    )}
    <Modal
      data-testid="AddOrEditMasterListModal"
      title={
        formFieldsValues.key
          ? stringsData.masterListDetailsContent.masterListDetailsContentEditButtonLabel
          : stringsData.masterListDetailsContent.masterListDetailsContentConfirmButtonLabel
      }
      onClose={() => handleCancelDetailsModalClick(setIsDetailsModalOpen)}
      toggle={isDetailsModalOpen}
      onConfirmHandler={() => {
        handleConfirmDetailsModalClick(setIsDetailsModalOpen);
      }}
      confirmActionLabel={
        formFieldsValues.key
          ? stringsData.masterListDetailsContent.masterListDetailsContentEditButtonLabel
          : stringsData.masterListDetailsContent.masterListDetailsContentConfirmButtonLabel
      }
      onCancelHandler={() => handleCancelDetailsModalClick(setIsDetailsModalOpen)}
      cancelActionLabel={
        stringsData.masterListDetailsContent.masterListDetailsContentCancelButtonLabel
      }
    >
      <AddOrEditMasterListComponent
        stringsData={stringsData}
        formFieldsValues={formFieldsValues}
        setFormFieldsValues={setFormFieldsValues}
        formFieldsValidation={formFieldsValidation}
      />
    </Modal>
  </MasterListWrapper>
);

export default MasterListComponent;

MasterListComponent.propTypes = {
  stringsData: PropTypes.shape({
    masterListHeader: PropTypes.shape({
      createMasterListButton: PropTypes.string,
    }),
    masterListDetailsContent: PropTypes.shape({
      masterListDetailsContentCancelButtonLabel: PropTypes.string,
      masterListDetailsContentConfirmButtonLabel: PropTypes.string,
      masterListDetailsContentEditButtonLabel: PropTypes.string,
    }),
  }).isRequired,
  numberOfPages: PropTypes.number.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  masterListList: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
  mappedMasterListList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  masterListStatusEnum: PropTypes.shape({}).isRequired,
  masterListStatusColorEnum: PropTypes.func.isRequired,
  handleMasterListSearchBarInputChange: PropTypes.func.isRequired,
  handleMasterListPaginationClick: PropTypes.func.isRequired,
  masterListQueryStrings: PropTypes.shape({}).isRequired,
  formFieldsValues: PropTypes.shape({
    key: PropTypes.string,
  }).isRequired,
  setFormFieldsValues: PropTypes.func.isRequired,
  formFieldsValidation: PropTypes.shape({}).isRequired,
  isDetailsModalOpen: PropTypes.bool.isRequired,
  setIsDetailsModalOpen: PropTypes.func.isRequired,
  handleConfirmDetailsModalClick: PropTypes.func.isRequired,
  handleCancelDetailsModalClick: PropTypes.func.isRequired,
  handleMasterListEditButtonClick: PropTypes.func.isRequired,
};

MasterListComponent.defaultProps = {};
